import type { ReactNode } from 'react';
import type { Permission } from '../auth/permissions';
import { useCan } from '../auth/permissions';
import { ForbiddenView } from './ForbiddenView';

/**
 * Sayfa guard'ı (SEOAI-47). İzin yoksa içerik RENDER EDİLMEZ ve kullanıcıya
 * neden göremediği söylenir.
 *
 * Bu bir GÜVENLİK sınırı DEĞİL, bir arayüz nezaketidir: URL elle yazılsa bile
 * veriyi backend 403 ile reddeder (rbac-design §7 — savunma derinliği). Burada
 * durdurmak, kullanıcıyı boş/kırık bir ekranla baş başa bırakmamak içindir.
 */
export function RequirePermission({
  permission,
  children,
}: {
  permission: Permission;
  children: ReactNode;
}) {
  const can = useCan();

  return can(permission) ? <>{children}</> : <ForbiddenView permission={permission} />;
}
